import Vue from "vue";
import VueI18n from "vue-i18n";
import uk from "./locales/uk.json";
import en from "./locales/en.json";
import ru from "./locales/ru.json";

Vue.use(VueI18n);

const STORAGE_KEY = "app_locale";
const SUPPORTED_LOCALES = ["uk", "en", "ru"];
const DEFAULT_LOCALE = "uk";

function resolveLocale() {
  const savedLocale =
    typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;

  if (savedLocale && SUPPORTED_LOCALES.includes(savedLocale)) {
    return savedLocale;
  }

  return DEFAULT_LOCALE;
}

const i18n = new VueI18n({
  locale: resolveLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    uk,
    en,
    ru,
  },
});

export function setAppLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) {
    return;
  }

  i18n.locale = locale;

  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, locale);
  }
}

export default i18n;
